/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  HangarPlan,
  HangarPlanSummary,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Shared Hangar Plan
 */
export const publicHangarPlan = (
    token: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      token = toValue(token);

      return axiosClient<HangarPlan>(
      {url: `/public/hangar-plans/${token}`, method: 'GET', signal
    },
      );
    }




export const getPublicHangarPlanQueryKey = (token: MaybeRefOrGetter<string>,) => {
    return [
    'public','hangar-plans',token
    ] as const;
    }


export const getPublicHangarPlanQueryOptions = <TData = Awaited<ReturnType<typeof publicHangarPlan>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(token: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangarPlan>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicHangarPlanQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicHangarPlan>>> = ({ signal }) => publicHangarPlan(token, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(token) !== null && toValue(token) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicHangarPlan>>, TError, TData>
}

export type PublicHangarPlanQueryResult = NonNullable<Awaited<ReturnType<typeof publicHangarPlan>>>
export type PublicHangarPlanQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Shared Hangar Plan
 */

export function usePublicHangarPlan<TData = Awaited<ReturnType<typeof publicHangarPlan>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 token: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangarPlan>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicHangarPlanQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Shared Hangar Plan Summary
 */
export const publicHangarPlanSummary = (
    token: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      token = toValue(token);

      return axiosClient<HangarPlanSummary>(
      {url: `/public/hangar-plans/${token}/summary`, method: 'GET', signal
    },
      );
    }




export const getPublicHangarPlanSummaryQueryKey = (token: MaybeRefOrGetter<string>,) => {
    return [
    'public','hangar-plans',token,'summary'
    ] as const;
    }


export const getPublicHangarPlanSummaryQueryOptions = <TData = Awaited<ReturnType<typeof publicHangarPlanSummary>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(token: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangarPlanSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicHangarPlanSummaryQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicHangarPlanSummary>>> = ({ signal }) => publicHangarPlanSummary(token, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(token) !== null && toValue(token) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicHangarPlanSummary>>, TError, TData>
}

export type PublicHangarPlanSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof publicHangarPlanSummary>>>
export type PublicHangarPlanSummaryQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Shared Hangar Plan Summary
 */

export function usePublicHangarPlanSummary<TData = Awaited<ReturnType<typeof publicHangarPlanSummary>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 token: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangarPlanSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicHangarPlanSummaryQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






